import { base64Encode } from '@finect/front-utils/base64';
export const getBlobAction = action => base64Encode(JSON.stringify(action));